import { render, staticRenderFns } from "./UrlDepth.vue?vue&type=template&id=06bf1626&"
import script from "./UrlDepth.vue?vue&type=script&lang=js&"
export * from "./UrlDepth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports